$(function () {
  // 移动端
  if (isMedium) {
    newSwiper('#swiper', {
      loop: true,
      slidesPerView: isMobile ? 3 : 4,
      spaceBetween: 10,
      centeredSlides: true,
      slideToClickedSlide: true,
      onSlideChangeEnd: function (swiper) {
        var idx = swiper.realIndex
        $('.business--article').eq(idx).addClass('business--article-active').siblings().removeClass('business--article-active')
      }
    })

  } else {
    // pc端
    newSwiper('#swiper', {
      loop: true,
      slidesPerView: 5,
      spaceBetween: 10,
      height: 360,
      centeredSlides: true,
      slideToClickedSlide: true,
      onSlideChangeEnd: function (swiper) {
        var idx = swiper.realIndex
        $('.business--article').eq(idx).addClass('business--article-active').siblings().removeClass('business--article-active')
      }
    })
  }
})